/**
 * Navigation Table of Content.
 */

function tocNavigation(groupElement, triggerElement, classListActive) {
	const tocItems = document.querySelectorAll(groupElement);

	tocItems.forEach((item) => {
		const trigger = item.querySelector(triggerElement);
		trigger.addEventListener('click', () => {
			item.classList.toggle(classListActive);
		});
	});
}

function tocAddActiveClassToParentLinks() {
	const rootElement = document.querySelector('.em-toc');
	if (!rootElement) return; // Ensure the root element exists

	// Get all <a> tags with href starting with #
	const links = rootElement.querySelectorAll('a[href^="#"]');

	// Add a click event listener to each <a> tag
	links.forEach((link) => {
		link.addEventListener('click', () => {
			// event.preventDefault(); // Prevent the default behavior of the link
			const parent = link.parentElement; // Get the parent of the clicked <a> tag

			// Remove 'is-active' class from all direct parents of <a> tags
			links.forEach((otherLink) => {
				const otherParent = otherLink.parentElement;
				if (otherParent !== parent) {
					otherParent.classList.remove('is-active');
				}
			});

			// Add 'is-active' class to the parent of the clicked <a> tag
			parent.classList.add('is-active');
		});
	});
}

function tocCheckChildren(elParent, elCheck, elCSS) {
	const parentElements = document.querySelectorAll(elParent);

	// Loop through each "my-nav" element
	parentElements.forEach((item) => {
		// Check if it has a child with the class elCheck
		if (item.querySelector(elCheck)) {
			// If it has the child, add the class "elParent" element
			item.classList.add(elCSS);
		}
	});
}

// Invoke the function when the DOM is loaded.
document.addEventListener('DOMContentLoaded', () => {
	tocAddActiveClassToParentLinks();
	tocNavigation('.em-toc__group', '.em-toc__trigger', 'is-open');
	tocCheckChildren('.em-toc__nav', '.em-toc__group-content', 'em--has-sub-links');
});
